import React from 'react';

import { Link } from 'react-router-dom';

const Breadcrumb = ({ pageTitle }) => {
    return (
        <div className="db-breadcrumb mb-6">
            <ul className="db-breadcrumb-list">
                <li className="db-breadcrumb-item">
                    <Link className="db-breadcrumb-link" to={`/admin/dashboard`}>
                        Dashboard
                    </Link>
                </li>
                <li className="db-breadcrumb-item">
                    <span>{pageTitle}</span>
                </li>
            </ul>
        </div>
    );
};

export default Breadcrumb;
